module.exports = __webpack_public_path__ + "static/media/47.f0a9485e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/47.jpg
// module id = 737
// module chunks = 0